module.exports = __webpack_public_path__ + "site/img/23.209cb9f2.jpg";